<div class="person-title">
  {{ label$ | async }}
</div>
